import {buildOpenChangePasswordSearch} from './build-open-change-password-search'
import {resolveChangePasswordLegacyPath} from './can-use-new-portal-change-password'
import {getNewPortalBaseUrl} from './get-new-portal-base-url'
import {isPortalRouteHybridEnabled} from './is-portal-route-hybrid-enabled'
import type {SessionBridgeResult} from './session-bridge-result'
import {submitSessionBridgeToNewPortal} from './submit-session-bridge-to-new-portal'

export function navigateToChangePasswordOnNewPortal(userPermissions: string[]): SessionBridgeResult | null {
  if (!isPortalRouteHybridEnabled()) return null
  if (!getNewPortalBaseUrl()) return {ok: false, reason: 'missing_new_portal_url'}

  const legacyBase = resolveChangePasswordLegacyPath(window.location.pathname, userPermissions)
  if (!legacyBase) return null

  const search = buildOpenChangePasswordSearch(legacyBase)

  return submitSessionBridgeToNewPortal({legacyPath: legacyBase, search})
}
